export = {
  techKind: {
    aces: "Aces",
    double_faults: "Lỗi kép",
    first_serve: "1st serve",
    first_serve_rate: "Tỉ lệ 1st serve",
    second_serve: "2nd serve",
    second_serve_rate: "Tỉ lệ 2nd serve",
    break_points: "Break points",
    break_points_percent: "Break points %",
    total_points: "Tổng số điểm",
    first_serve_points: "Điểm 1st serve",
    first_serve_points_rate: "Tỉ lệ điểm 1st serve",
    second_serve_points: "Điểm 2nd serve",
    second_serve_points_rate: "Tỉ lệ điểm 2nd serve",
  },
  percentKeys: [
    "first_serve_rate",
    "second_serve_rate",
    "break_points_percent",
    "first_serve_points_rate",
    "second_serve_points_rate",
  ],
  showPreKeys: [
    "first_serve",
    "second_serve",
    "break_points",
    "first_serve_points",
    "second_serve_points",
  ],
  groupType: {
    0: "Hard",
    1: "Hard",
    2: "Grass",
    3: "Clay",
    4: "Clay",
    5: "Hardcourt outdoor",
    6: "Carpet indoor",
    7: "Synthetic indoor",
    8: "Synthetic outdoor",
    9: "Hardcourt indoor",
    10: "Clay",
  },
};
